import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Delete } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';

import RichContent from '@components/RichContent/RichContent';
import { getParsedText } from '@views/AdminInquiriesPage/AdminInquiryList/SupplementInquiryDetails/SupplementInformationForm/utils';

import { ICannedResponseItemProps } from './CannedResponseItem.interface';

import './style.scss';

const CannedResponseItem: FC<ICannedResponseItemProps> = ({ data, onApply, onDelete }) => {
  const { t } = useTranslation();

  const handleApply = useCallback(() => {
    onApply(data.comment);
  }, [data, onApply]);

  const handleDelete = useCallback(() => {
    onDelete(data.id);
  }, [data, onDelete]);

  return (
    <div className="canned-response-item">
      <IconButton className="canned-response-item__delete" color="error" onClick={handleDelete}>
        <Delete />
      </IconButton>

      <div className="canned-response-item__name">
        <RichContent>{getParsedText(data.comment)}</RichContent>
      </div>

      <Button className="canned-response-item__apply" variant="text" onClick={handleApply}>
        {t('adminInquiries.useComment')}
      </Button>
    </div>
  );
};

export default CannedResponseItem;
